module.exports = __webpack_public_path__ + "static/media/new-canvas-mobile.0d3ab66b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CanvasEditor/new-canvas-mobile.svg
// module id = 682
// module chunks = 0